import { React, useState, useEffect,useContext } from 'react';
import {useNavigate } from "react-router-dom"
import SubHeader from './SubHeader';
import {NavLink,DropdownToggle, DropdownMenu, DropdownItem, ListInlineItem, Dropdown} from 'reactstrap';
import projectPlaceholderImg from '../../assets/images/no-projects.png'
import axios from '../../api/axios';
import { GlobalContext } from '../../App';
import HoverTooltip from '../global/Tooltip';
import { toast } from 'react-toastify';
import TopHeader from './TopHeader';
import { BsChevronRight } from "react-icons/bs";

const GanttChart = () => {
    const navigate = useNavigate();
    const { rolexModuleData,user_id,roles,userProfile } = useContext(GlobalContext);
    const currentDate = new Date().toISOString().substr(0, 10)
    var url = "/"+ window.location.href?.split("/")[3];
    const [dateArray, setDateArray] = useState([]);
    const [uniqueMonths, setUniqueMonths] = useState([]);
    const weekdays = ['S', 'M', 'T', 'W', 'Th', 'F', 'S'];
    const renderDays = (StartDate, EndDate) => {
        const days = [];
        const startDate = new Date(StartDate);
        const endDate = new Date(EndDate);

        while (startDate <= endDate) {
            const dayOfWeek = weekdays[startDate.getDay()];
            days.push({ date: new Date(startDate), dayOfWeek });
            startDate.setDate(startDate.getDate() + 1);
        }
        setDateArray(days)
        const months = days.map(item => item.date.toLocaleString('default', { month: 'long', year: 'numeric' }));
        const uniqueMonths = [...new Set(months)];
        setUniqueMonths(uniqueMonths)
    };

    // ------------------------------------------------------------- Get Task List ---------------------------------

    const [taskList, setTaskList] = useState([]);
    const [projectStatus, setProjectStatus] = useState();
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const toggle = () => setDropdownOpen((prevState) => !prevState);
    const [projectList, setProjectList] = useState([]);

    
  // -------------------------------------------------------- Get User Data --------------------------------------
  const getUserData = () => {
    // setLoading(true);
    const UserListCriteria  =  roles?.find((data1) => data1?.role_id === 1001) ? '' : userProfile || '';
    axios.get(`/getUserData?UserListCriteria=${JSON?.stringify(UserListCriteria)}`).then((response, error) => {
        const userTaskList = response?.data?.[0]?.user_data
          ?.filter((item) => item?.user_id === user_id)?.[0]
          ?.user_x_task?.filter((data) => data?.task_access === 1)
          ?.map((data) => data?.task_id);
        getTaskList(userTaskList);
        // setLoading(false);
      })
      .catch((error) => {
        const statusCode = error.response ? error.response.status : null;
        // Handle the error here based on the status code received
        if (statusCode === 500) {
          toast.error("getTaskList : Internal Server Error !", {
            position: toast.POSITION.TOP_RIGHT,
            theme: "colored",
            autoClose: 2000
          });
          // Handle 500 Internal Server Error
        } else if (statusCode === 404) {
          toast.error("Page Not Found !", {
            position: toast.POSITION.TOP_RIGHT,
            theme: "colored",
            autoClose: 2000
          });
          // Handle 404 Not Found
        } else {
          console.log(error)
          toast.error("No getTaskList API Response !", {
            position: toast.POSITION.TOP_RIGHT,
            theme: "colored",
            autoClose: 2000
          });
          // Handle other error scenarios
        }
      });
  };
 // ------------------------------------------------------- Get Task Data ----------------------------------------
  const getTaskList = (userTaskList) => {
           axios.post('/getTaskList').then((response)=>{            
                const task = response?.data?.[0]?.task_data?.filter((data) =>( roles?.filter((data) => data?.role_id === 1001)?.length > 0 ? data :userTaskList?.includes(data?.task_id)) && data?.task_status !== "Pipeline" && data?.task_status !== "Cancelled")
                setTaskList(task);
                const maxStartDate = task?.length > 0 ? task?.reduce((min, obj) => new Date(obj.task_start_date) < new Date(min.task_start_date) ? obj : min)?.task_start_date : "";
                const maxEndDate = task?.length > 0 ? task?.reduce((max, obj) => new Date(obj.task_end_date) > new Date(max.task_end_date) ? obj : max)?.task_end_date : "";
                renderDays(maxStartDate,maxEndDate)
                const projectList = task?.filter((obj, index, arr) => arr.findIndex(o => o.project_id === obj.project_id) === index)?.map(item => ({ label: item?.project_master?.[0]?.project_title, value: item?.project_id })) ?? [];
                setProjectList(projectList);                
                setProjectStatus(projectList?.[0]);
            }).catch((error) => {
                const statusCode = error.response ? error.response.status : null;
                // Handle the error here based on the status code received
                if (statusCode === 500) {
                  toast.error("getTaskList : Internal Server Error !", {
                    position: toast.POSITION.TOP_RIGHT,
                    theme: "colored",
                    autoClose: 2000
                  });
                  // Handle 500 Internal Server Error
                } else if (statusCode === 404) {
                  toast.error("Page Not Found !", {
                    position: toast.POSITION.TOP_RIGHT,
                    theme: "colored",
                    autoClose: 2000
                  });
                  // Handle 404 Not Found
                } else {
                  console.log(error)
                  toast.error("No getTaskList API Response !", {
                    position: toast.POSITION.TOP_RIGHT,
                    theme: "colored",
                    autoClose: 2000
                  });
                  // Handle other error scenarios
                }
              });
  }
  // ---------------------------------------------------------- Mantain Log History ------------------------------
const postLogHistory = () =>{
  const param = {
    user_id : user_id,
    module_name : 'Gantt Chart',
    operationPerformed : 'navigate to gantt chart screen',
  }
  axios.post('/postLogHistory',param);
}
 // -------------------------------------------------------- Use Effect -----------------------------------------
  useEffect(() => {
    getUserData();
    //postLogHistory();
  }, [])
    return (
        <>
         <TopHeader
      breadCrumb = {
          <>
          <li className="nav-item"><a  onClick={() => navigate("/home")} className="nav-link">Home <BsChevronRight /></a></li> 
          <li className="nav-item"><span>Gantt Chart</span></li>
          </>
        }
      />
            <SubHeader
                SubHeaderTitle="Gantt Chart"
                userStatus={projectList?.length > 0 ? 
                    <ListInlineItem>
                        <Dropdown isOpen={dropdownOpen} toggle={toggle} direction="down">
                            <DropdownToggle className='activeuser' caret>{projectStatus?.label}</DropdownToggle>
                            <DropdownMenu >
                                {projectList?.map((data) => (
                                    <DropdownItem onClick={() => setProjectStatus(data)}>{data?.label}</DropdownItem>
                                ))}
                            </DropdownMenu>
                        </Dropdown>
                    </ListInlineItem> : null
                }
            />
            <div className="gantt-chart contentInnerWrap">
                <div className="table-wrapper">
                {/* <Scrollbars
                    autoHeight
                    autoHeightMin={162}
                    autoHeightMax={430}
                    autoWidth={true}
                    className="sideBarOverflowChart"
                    style={{ maxWidth: 1500}}
                > */}
                    <table>
                        <thead>
                            <tr>
                                <th rowSpan="2" style={{ width: "420px", fontSize: "1.125rem", fontWeight: "normal", textAlign: 'left' }}>Task</th>
                                {uniqueMonths?.map((data) => (
                                    <th colSpan={dateArray?.filter((item) => item.date.toLocaleString('default', { month: 'long', year: 'numeric' }) === data)?.length}> {data} </th>
                                ))}
                            </tr>
                            <tr>
                                {dateArray?.map((day, index1) => (
                                    <th>
                                        <span style={{display: 'block'}}>{day.date.getDate()}</span>
                                        <span style={{display: 'block'}}>{day.dayOfWeek}</span> </th>
                                ))}
                            </tr>
                        </thead>
            
                    <tbody>

                        {taskList?.length > 0 ? taskList?.filter((data) => projectStatus?.value ===  data?.project_id)?.map((data,index) =>
        
                            <tr>
                                <td style={{ width: "420px", display: "inline-block", textAlign: 'left', minHeight: '45px', backgroundColor: data?.task_status === "Completed" ? "#87ab64" : "" }}><NavLink className="d-inline-block ps-0" style={{ color: data?.task_status === "Completed" ? "#ffffff" : "" }}  onClick={() => navigate('/task-detail' + `?param1=${btoa(data?.task_id)}`)}>TD-{data?.task_code} {data?.task_title}</NavLink></td>
                                {dateArray?.map((day, index1) => (
                                <td className= {data?.tasks_timesheet?.filter((data)=> data?.Date === day.date.toISOString().split('T')?.[0] && (((rolexModuleData?.filter((data1) => url === data1?.description && data1?.create === 1)?.length > 0 )|| roles?.filter((data) => data?.role_id === 1001)?.length > 0 )? data : data.user_id === user_id))?.length > 0 ? "completed" : (currentDate > day.date.toISOString().split('T')?.[0]  ? (data?.task_start_date > day.date.toISOString().split('T')?.[0] ?  "archiveDates": (data?.task_end_date >= day.date.toISOString().split('T')?.[0] ? "pending" : "archiveDates") ): " " ) }colspan="1">
                                    <HoverTooltip arrow title={data?.tasks_timesheet?.filter(obj => obj.Date === day.date.toISOString().split('T')?.[0] && (((rolexModuleData?.filter((data1) => url === data1?.description && data1?.create === 1)?.length > 0)|| roles?.filter((data) => data?.role_id === 1001)?.length > 0 ) ? obj : obj.user_id === user_id))?.map((obj) => <div>{obj?.user_master?.[0]?.name + " ("  + (obj.Duration != null && obj.Duration != '' ? Number(obj.Duration) : ((new Date(`1970-01-01T${obj.end_time}`)).getTime() - (new Date(`1970-01-01T${obj.start_time}`)).getTime()) / 1000 / 60 / 60)} hr{")"}</div> ) || ""}>
                                    <NavLink>
                                        {data?.tasks_timesheet?.filter(obj => obj.Date === day.date.toISOString().split('T')?.[0] && (((rolexModuleData?.filter((data1) => url === data1?.description && data1?.create === 1)?.length > 0)|| roles?.filter((data) => data?.role_id === 1001)?.length > 0 ) ? obj : obj.user_id === user_id))?.reduce((total, obj) => { const duration = obj.Duration != null && obj.Duration != '' ? Number(obj.Duration) : ((new Date(`1970-01-01T${obj.end_time}`)).getTime() - (new Date(`1970-01-01T${obj.start_time}`)).getTime()) / 1000 / 60 / 60; 
                                        return duration > 0 ? total + duration : total;}, 0) || ""}
                                    </NavLink>
                                    </HoverTooltip>
                                    </td>))}                         
                            </tr>
                            
                        ) : <tr>
                                <td colSpan={dateArray?.length + 1}>
                                    <img src={projectPlaceholderImg} alt="No Task" style={{width: '250px', height: 'auto'}}/>
                                    <h4 className="defaultPlaceholderText">There are no tasks!</h4>
                                </td>
                            </tr>
                        }
                        
                    </tbody>
                          
                    </table>
                    {/* </Scrollbars> */}
                </div>
            </div>


        </>
    )
}
export default GanttChart